// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__F0J7D","subTitle":"styles_subTitle__1FI3r","reportButton":"styles_reportButton__3uz90","subjectInput":"styles_subjectInput__x9YlO"};